import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownOptionSelected(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownOptionSelected',
    baseStyle: {
      color: theme.colors.primary
    }
  };
}
